import React, {useEffect, useState}				from 'react';
import {useParams, useSearchParams}				from 'react-router-dom';

import {useAppSelector, useAppDispatch}			from '../app/hooks';
import {login, clearError}						from '../redux/user/user';
import {InputValues}							from '../ressources/components/Input/interface';

import PasswordReset							from './PasswordReset';
import Input									from '../ressources/components/Input';
import Button									from '../ressources/components/Button';
import Icon										from '../ressources/components/Icon';
import Checkbox									from '../ressources/components/Checkbox';
import Load										from '../ressources/components/Load';
import Modal									from '../ressources/components/Modal';

import {ft_fetchPappers, isValidSiretOrSiren}	from '../ressources/functions/companyFunction';
import ft_cssVar								from '../ressources/functions/getCssVar';

import img_arrowRight							from '../ressources/images/icon/arrow/right.svg';
import img_info									from '../ressources/images/icon/check.svg';
import img_google								from '../ressources/images/logo/google.png';

import LANGUAGE									from '../ressources/language';
import * as API									from '../ressources/API';
import {regex_email, regex_phone}				from '../ressources/data/regex';
import {GLOBAL_DOMAIN}							from '../ressources/data/email';

import './Login.css';

const APIURLROOT = import.meta.env.VITE_API || 'http://localhost:3020';

interface PAPPERS_RESULT {
	nom_entreprise: string,
	siege: {
		siret: string
	}
}
interface PAPPERS {
	resultats_siren: PAPPERS_RESULT[],
	resultats_siret: PAPPERS_RESULT[]
}

interface CompanyList {
	nom_entreprise: string,
	denomination: string,
	domaine_activite: string,
	siren: string,
	siege: {
		adresse_ligne_1: string,
		code_postal: string,
		ville: string,
		siret: string
	}
}

let	TIMEOUT: NodeJS.Timeout | null = null;


function	Login() {
	const dispatch = useAppDispatch();
	const error = useAppSelector(state => state.user.error);
	const isLoad = useAppSelector(state => state.user.isLoad);
	const lang = useAppSelector(state => state.settings.lang);

	const [email, set_email] = useState<InputValues>('');
	const [password, set_password] = useState<InputValues>('');
	const [firstname, set_firstname] = useState<InputValues>('');
	const [lastname, set_lastname] = useState<InputValues>('');
	const [company, set_company] = useState<InputValues>('');
	const [showList, set_showList] = useState(false);
	const [siret, set_siret] = useState<InputValues>('');
	const [listHover, set_listHover] = useState(false);
	const [companyList, set_companyList] = useState<CompanyList[]>([]);
	const [phone, set_phone] = useState<InputValues>('');
	const [remember, set_remember] = useState(false);
	const [view, set_view] = useState('');
	const [errorResponse, set_errorResponse] = useState('');
	const [confirm, set_confirm] = useState(false);

	const [mfaModal, set_mfaModal] = useState(false);
	const [mfaKey, set_mfaKey] = useState('');

	const [registerError, set_registerError] = useState<{[key: string]: string | boolean}>({});
	const [load, set_load] = useState(false);
	const [loadCompany, set_loadCompany] = useState(false);

	const [searchParams] = useSearchParams();

	const TEXTE = LANGUAGE(lang);
	const params = useParams();

	useEffect(() => {
		if (view === 'forget')
			set_confirm(false);
		set_errorResponse('');
	}, [view]);

	useEffect(() => set_registerError({...registerError, siret: false}), [siret]);
	useEffect(() => set_registerError({...registerError, email: false}), [email]);
	useEffect(() => set_registerError({...registerError, phone: false}), [phone]);

	useEffect(() => {
		if (params['*'] === 'register')
			return set_view('register');
		set_view('');
	}, []);

	useEffect(() => set_load(false), [registerError]);

	useEffect(() => {
		if (error !== 'mfa')
			return;
		set_mfaModal(true);
		dispatch(clearError());
	}, [error]);

	useEffect(() => set_mfaKey(''), [mfaModal]);

	useEffect(() => {
		set_companyList([]);

		if (TIMEOUT)
			clearTimeout(TIMEOUT);
		if (`${company}`.length < 2)
			return set_loadCompany(false);

		if ((/^\d+$/).test(`${company}`) && [9, 14].includes(`${company}`.length)) {
			set_showList(false);
			return set_siret(company);
		}

		set_loadCompany(true);

		TIMEOUT = setTimeout(() => {
			set_loadCompany(false);
			fetch(`https://suggestions.pappers.fr/v2/?q=${company}`)
			.then(response => response.json())
			.then((result) => {
				if (result.resultats_nom_entreprise)
					return set_companyList(result.resultats_nom_entreprise);
			});
		}, 500);
	}, [company]);

	function checkError(name: string) {
		if (name === 'siret') {
			if (!siret || isValidSiretOrSiren(siret as string))
				return set_registerError({...registerError, siret: false});
			return set_registerError({...registerError, siret: TEXTE.login.error.siret});
		} else if (name === 'email') {
			if (email && !regex_email.test(email as string))
				return set_registerError({...registerError, email: TEXTE.users.emailNotValid});
			if (email && GLOBAL_DOMAIN.some(domain => (email as string).includes(domain)))
				return set_registerError({...registerError, email: TEXTE.login.error.proEmail});
			return set_registerError({...registerError, email: false});
		} else if (name === 'phone') {
			if (phone && !regex_phone.test(phone as string))
				return set_registerError({...registerError, phone: TEXTE.users.phoneNotValid});
			return set_registerError({...registerError, phone: false});
		}
	}

	async function onClick() {
		dispatch(clearError());

		if (view !== 'forget') {
			return dispatch(login({
				email:    email.toString(),
				password: password.toString(),
				mfaToken: mfaKey as string
			}));
		}

		API.forgetPassword(email as string)
		.then((response) => {
			if (response.error)
				return set_errorResponse(response.error === 'Too many request' ? TEXTE.login.tooManyRequest : response.error);
			set_email('');
			set_confirm(true);
			set_view('');
		});
	}

	async function createUser() {
		if (confirm) {
			set_confirm(false);
			return set_view('');
		}

		if (!firstname || !lastname || !email || !siret || registerError.email || registerError.siret)
			return;

		set_load(true);
		const papers: PAPPERS = await ft_fetchPappers(siret as string);

		if (!papers?.resultats_siren?.[0] && !papers?.resultats_siret?.[0])
			return set_registerError({...registerError, siret: TEXTE.login.error.siret});

		set_load(false);
		const finalSiret = papers.resultats_siren?.[0]?.siege.siret || papers.resultats_siret?.[0]?.siege.siret;
		const name = papers.resultats_siren?.[0]?.nom_entreprise || papers.resultats_siret?.[0]?.nom_entreprise;

		const useEmail = await API.checkEmailUse(email as string);
		const useSiret = await API.checkSiretUse(finalSiret);

		if (useSiret.data || useEmail.data)
			return set_registerError({...registerError, siret: TEXTE.login.error.siretIsUse});

		API.postCompany({
			name,
			societyName: name,
			crmId:       'new',
			siret:       finalSiret
		})
		.then((newCompany) => {
			if (!newCompany.status || !newCompany.data?.token?.data || newCompany.error)
				return set_registerError({...registerError, siret: newCompany.error});

			API.postUserPublic({
				email,
				phone,
				lastname,
				firstname,
				notif:      true,
				addMethod: 'autonomous',
				company:   newCompany.data._id,
				referer:   document.referrer || searchParams.get('referer') || undefined
			}, newCompany.data.token.data)
			.then((responseUser) => {
				if (!responseUser.status || responseUser.error)
					return set_registerError({...registerError, email: responseUser.error});

				window.dataLayer = window.dataLayer || [];
				window.dataLayer.push({
					email,
					phone,
					event:        'sign_up',
					lastName:     lastname,
					firstName:    firstname,
					login_method: 'email'
				});

				set_confirm(true);
				set_load(false);
			});
		});
	}

	function renderAbsoluteCompany() {
		const render: React.ReactElement[] = [];

		companyList.forEach((comp) => {
			render.push(
				<div
					onClick={() => {
						set_showList(false);
						set_siret(comp.siren);
						set_company(`${comp.denomination || comp.nom_entreprise} - ${comp.siren}`);
					}}
					className={'registerCompanyListItem'}
				>
					<span>{`${comp.denomination || comp.nom_entreprise} - ${comp.siren}`}</span>
					<span>{comp.domaine_activite}</span>
					<span>{`${comp.siege.adresse_ligne_1}, ${comp.siege.code_postal} ${comp.siege.ville}`}</span>
				</div>
			);
		});

		return (
			<div
				onMouseEnter={() => set_listHover(true)}
				onMouseLeave={() => set_listHover(false)}
				className={'registerCompanyList'}
			>
				{loadCompany && <Load center />}
				{render}
			</div>
		);
	}

	function renderRegister() {
		return (
			<div className={'loginFormContainer'}>
				<div className={`loginLogo ${view}`} />

				<div className={'loginText'}>
					<span>{TEXTE.login.register}</span>
					<span>{TEXTE.login.registerText}</span>
				</div>

				{confirm ?
					<span className={'weight-500 gray-600 text-center'}>{TEXTE.login.registerConfirm}</span>
					:
					<>
						<Input
							required
							value={firstname}
							onChange={set_firstname}
							title={TEXTE.global.firstname}
						/>

						<Input
							required
							value={lastname}
							onChange={set_lastname}
							title={TEXTE.global.lastname}
						/>

						<Input
							required
							value={email}
							onChange={set_email}
							title={TEXTE.global.email}
							error={registerError.email}
							onBlur={() => checkError('email')}
						>
							{!registerError.email && TEXTE.login.useForLogin}
						</Input>

						<Input
							required
							value={phone}
							onChange={set_phone}
							title={TEXTE.global.phone}
							error={registerError.phone}
							onBlur={() => checkError('phone')}
						/>

						<div
							style={{position: 'relative', width: '100%'}}
							onBlur={() => !listHover && set_showList(false)}
						>
							<Input
								required
								value={company}
								onChange={set_company}
								title={TEXTE.global.siret}
								error={registerError.siret}
								onFocus={() => set_showList(true)}
							/>

							{(showList && `${company}`.length > 1) && renderAbsoluteCompany()}
						</div>
					</>
				}

				<div className={'registerRoundContainer'}>
					<div className={'registerRound active'} />
					<div className={`registerRound ${confirm && 'active'}`} />
				</div>

				<Button
					fullWidth
					isLoad={load}
					onClick={createUser}
					disabled={!!(!firstname || !lastname || !email || !phone || !siret || registerError.email || registerError.siret)}
				>
					{confirm ? TEXTE.login.backToLogin : TEXTE.global.continue}
				</Button>

				{!confirm &&
					<div className={'registerExistingText'}>
						<span>{TEXTE.login.existingAccount}</span>
						<span onClick={() => set_view('')}>{TEXTE.login.login}</span>
					</div>
				}
			</div>
		);
	}

	if (params['*'] === 'resetPassword' && searchParams.get('id') && searchParams.get('token'))
		return <PasswordReset id={searchParams.get('id') || ''} token={searchParams.get('token') || ''} />;

	return (
		<div className={'loginMain'}>
			<div className={'loginContainer'}>
				{view === 'register' ?
					renderRegister()
					:
					<div className={'loginFormContainer'}>
						<div className={`loginLogo ${view}`} />

						<div className={'loginText'}>
							<span>{view === 'forget' ? TEXTE.login.forgotPassword : TEXTE.login.hello}</span>
							<span>{view === 'forget' ? TEXTE.login.weWillSendMail : TEXTE.login.niceToSeeYou}</span>
						</div>

						{confirm && <span className={'weight-500 gray-600'}>{TEXTE.login.forgetMailSend}</span>}

						<Input
							value={email}
							onChange={set_email}
							title={TEXTE.global.email}
						/>
						{view !== 'forget' &&
							<Input
								type={'password'}
								value={password}
								onChange={set_password}
								title={TEXTE.global.password}
							/>
						}

						{view !== 'forget' &&
							<div className={'loginRememberContainer'}>
								<Checkbox
									active={remember}
									onChange={set_remember}
									text={TEXTE.login.rememberMe}
								/>
								<div className={'loginForgotPassword'} onClick={() => set_view('forget')}>
									<span>{TEXTE.login.forgotPassword}</span>
									<Icon icon={img_arrowRight} />
								</div>
							</div>
						}

						{(view !== 'forget' && error) && <span className={'weight-500 error-600'}>{TEXTE.login.error[error]}</span>}
						{(view === 'forget' && errorResponse) && <span className={'weight-500 error-600'}>{errorResponse}</span>}

						<Button fullWidth onClick={onClick} isLoad={isLoad}>
							{view === 'forget' ? TEXTE.login.sendMail : TEXTE.login.login}
						</Button>

						{view === '' &&
							<>
								<a href={`${APIURLROOT}/auth/google`} className={'loginGoogle'}>
									<Button type={'secondary-gray'} iconBefore={img_google} fullWidth>
										{`${TEXTE.login.login} ${TEXTE.login.google}`}
									</Button>
								</a>

								<Button
									fullWidth
									type={'secondary-gray'}
									onClick={() => set_view('register')}
								>
									{TEXTE.login.createAccount}
								</Button>
							</>
						}
					</div>
				}
			</div>
			<div className={`loginBackground ${view}`} />

			{mfaModal &&
				<Modal
					confirmLoad={isLoad}
					confirmButton={onClick}
					onClose={() => set_mfaModal(false)}
					confirmButtonDisabled={(mfaKey as string || '').length !== 6}
					header={
						<Icon
							iconBorder
							icon={img_info}
							iconColor={ft_cssVar('warning-600')}
							type={'warning'}
						/>
					}
				>
					<span className={'text-lg weight-600 gray-900'}>{TEXTE.login.doubleAuth}</span>
					<br />
					<Input
						value={mfaKey}
						placeholder={'000000'}
						title={TEXTE.login.mfa}
						onChange={val => set_mfaKey((val as string || '').replace(/[^0-9]/gi, '').slice(0, 6))}
					/>
					{error ? <span className={'weight-500 error-600'}>{TEXTE.login.error[error]}</span> : <></>}
					<br />
				</Modal>
			}
		</div>
	);
}

export default Login;
